<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ehu1fq/tc-custom/9780316026307.jpg?1736424837001" alt="This image is the cover for the book Italian Lover"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Italian Lover
      </h1>
      <p class="bookDescription body article font2">
        <b>An exhilarating novel of romance, art, and food in Florence, featuring the beloved Margot Harrington, who graced Robert Hellenga's <i>The Sixteen Pleasures</i>.</b><br/><br/> Margot Harrington's memoir about her discovery in Florence of a priceless masterwork of Renaissance erotica -- and the misguided love affair it inspired - is now, 25 years later, being made into a movie. Margot, with the help of her lover, Woody, writes a script that she thinks will validate her life. Of course their script is not used, but never mind -- happy endings are the best endings for movies, as Margot eventually comes to see. <br/><br/> At the former convent in Florence where <i>The Sixteen Pleasures</i> -- now called <i>The Italian Lover</i> - - is being filmed, Margot enters into a drama she never imagined, where her ideas of home, love, art, and aging collide with the imperatives of commerce and the unknowability of other cultures and other people.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Hellenga
      </h2>
      
      <p class="authorDescription body article"><B>Robert Hellenga</B> received his B.A. from the University of Michigan and studied at Queen's University in Belfast and the University of North Carolina before completing a Ph.D. in English Literature at Princeton University. He is a professor at Knox College in Galesburg, Illinois, and the author of the novels <I>The Sixteen Pleasures</I>, <I>The Fall of a Sparrow</I>, <I>Blues Lessons</I>, and <I>Philosophy Made Simple</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0818698e